<ion-content [scrollEvents]="true" no-bounce>
  <app-user-cork-board
    *ngIf="user"
    [class.open]="userCorkBoardExpanded"
    (corkBoardExpandedEmitter)="corkBoardExpandedHandler($event)"
    (click)="toggleDropdown(false)"
  >
  </app-user-cork-board>
  <div class="content-wrapper" [class.expanded]="userCorkBoardExpanded">
    <div class="shell-toolbar">
      <app-toolbar-logo (click)="toggleDropdown(false)"> </app-toolbar-logo>
      <app-toolbar-nav
        (dropdownEvent)="toggleDropdown($event)"
        (serviceHealthRequested)="handleServiceHealthRequest($event)"
      >
      </app-toolbar-nav>
      <app-toolbar-profile-nav
        *ngIf="user"
        [user]="user"
        (dropdownEvent)="toggleDropdown($event)"
      ></app-toolbar-profile-nav>
      <div class="user-dropdown" [class.show]="dropdownActive" (click)="toggleDropdown(false)">
        <ul class="user-dropdown-actions">
          <li (click)="addNewCorkBoardItem()">Add Photos</li>
          <li routerLink="/user/profile">Edit Profile</li>
          <li *ngIf="impersonator" (click)="stopImpersonation()">Return to admin</li>
          <li (click)="signOut()">Logout</li>
        </ul>
      </div>
    </div>
    <ion-router-outlet class="main-router-oulet" main (click)="toggleDropdown(false)"> </ion-router-outlet>
    <div
      #serviceStatusPanel
      class="environment-status-panel"
      *ngIf="serviceStatus && serviceStatusPanelRendered"
      [class.is-visible]="serviceStatusPanelVisible"
      [class.is-floating]="serviceStatusPosition !== null"
      [style.top.px]="serviceStatusPosition?.top"
      [style.left.px]="serviceStatusPosition?.left"
    >
      <img class="status-brand" src="/assets/everybody-graphic@2x.png" alt="Everybody is a Somebody" />
      <div class="status-card" [class.is-degraded]="serviceStatus.health === 'degraded'">
        <div class="status-print-header">
          <span class="status-print-title">Followup Master · Service Health & Release Change Log</span>
          <span class="status-print-versions">Frontend v{{ version }} · API v{{ serviceStatus.apiVersion }} · DB {{ serviceStatus.databaseName }} ({{ serviceStatus.environment }})</span>
        </div>
        <div class="status-header">
          <div class="status-health">
            <span
              class="status-dot"
              [class.is-ok]="serviceStatus.health === 'ok'"
              [class.is-degraded]="serviceStatus.health === 'degraded'"
            ></span>
            <span class="status-title">Service Health</span>
          </div>
          <div class="status-header-actions">
            <button
              type="button"
              class="status-drag-handle"
              (mousedown)="startServiceStatusDrag($event)"
              (touchstart)="startServiceStatusDrag($event)"
            >
              Drag
            </button>
            <span class="status-frontend-version">FE v{{ version }}</span>
            <button type="button" class="status-print" (click)="printServiceHealth()">Print</button>
            <button type="button" class="status-close" (click)="closeServiceStatusPanel()">Close</button>
          </div>
        </div>
        <div class="status-line" [title]="serviceStatus.apiHost">
          <span class="status-label">API</span>
          <span class="status-value">{{ serviceStatus.apiName }} · v{{ serviceStatus.apiVersion }}</span>
        </div>
        <div class="status-line">
          <span class="status-label">DB</span>
          <span class="status-value">{{ serviceStatus.databaseRole }} · {{ serviceStatus.databaseName }}</span>
        </div>
        <div class="status-line">
          <span class="status-label">Env</span>
          <span class="status-value">{{ serviceStatus.environment }} · {{ serviceStatus.healthLabel }}</span>
        </div>
        <div class="status-line">
          <span class="status-label">Timing</span>
          <span class="status-value">{{ serviceStatus.latencySummary }}</span>
        </div>
        <div class="status-line">
          <span class="status-label">Profiler</span>
          <span class="status-value">{{ serviceStatus.profilingSummary }}</span>
        </div>
        <div class="status-line">
          <span class="status-label">Checked</span>
          <span class="status-value">{{ serviceStatus.checkedAtLabel }}</span>
        </div>
        <button type="button" class="status-line status-line-action" (click)="toggleChangeLog()">
          <span class="status-label">Version Change Log</span>
          <span class="status-value">{{ changeLogExpanded ? 'Hide' : 'Open' }}</span>
        </button>
        <div class="status-change-log" *ngIf="changeLogExpanded">
          <div class="change-log-search-row">
            <span class="status-label">Search Version</span>
            <input
              type="text"
              class="change-log-search-input"
              [value]="changeLogVersionQuery"
              (input)="updateChangeLogVersionQuery($event)"
              placeholder="Filter known versions"
            />
          </div>
          <div class="change-log-version-list" *ngIf="filteredChangeLogVersions.length; else noKnownVersions">
            <button
              type="button"
              class="change-log-version-chip"
              *ngFor="let release of filteredChangeLogVersions"
              [class.is-selected]="release.version === selectedChangeLogVersion"
              (click)="selectChangeLogVersion(release.version)"
            >
              {{ release.version }}
            </button>
          </div>
          <div class="change-log-summary">{{ changeLogSummary }}</div>
          <ng-template #noKnownVersions>
            <div class="change-log-empty">No markdown-backed versions match that search.</div>
          </ng-template>
          <div class="change-log-release" *ngFor="let release of visibleChangeLogReleases">
            <div class="change-log-release-header">
              <span class="change-log-release-version">v{{ release.version }}</span>
              <span class="change-log-release-date">{{ release.recordedAt }}</span>
            </div>
            <div class="change-log-release-label">{{ release.label }}</div>
            <div class="change-log-release-notes">{{ release.notes }}</div>
            <div class="change-log-entry" *ngFor="let entry of release.entries">
              <div class="change-log-entry-header">
                <span class="change-log-entry-scope">{{ entry.scope }}</span>
                <span class="change-log-entry-source">{{ entry.source }}</span>
              </div>
              <div class="change-log-entry-summary">{{ entry.summary }}</div>
              <div class="change-log-entry-evidence">{{ entry.evidence }}</div>
            </div>
          </div>
        </div>
        <div class="status-error" *ngIf="serviceStatus.error">{{ serviceStatus.error }}</div>
      </div>
    </div>
  </div>
</ion-content>
